export function CityComparison() {
  const comparisonData = [
    {
      category: 'Licensing Complexity',
      edmonton: 'Moderate - Business license only',
      calgary: 'High - Development permit + business license'
    },
    {
      category: 'Primary Residence Requirement',
      edmonton: 'No - Investment properties allowed',
      calgary: 'Yes - Primary residence only'
    },
    {
      category: 'Annual Rental Day Limit',
      edmonton: 'None - Unlimited rental days',
      calgary: '180 days maximum per year'
    },
    {
      category: 'Owner Presence Required',
      edmonton: 'No - Can rent entire property',
      calgary: 'Yes - For entire-home rentals'
    },
    {
      category: 'Density Restrictions',
      edmonton: 'No - Multiple STRs per block allowed',
      calgary: 'Yes - One per block face maximum'
    },
    {
      category: 'Application Timeline',
      edmonton: '6-10 weeks total',
      calgary: '8-12 weeks total'
    },
    {
      category: 'First Year Costs',
      edmonton: '$1,400-$2,500',
      calgary: '$1,800-$2,800'
    },
    {
      category: 'Annual Renewal Costs',
      edmonton: '$150 + insurance',
      calgary: '$100 + insurance'
    },
    {
      category: 'Zoning Flexibility',
      edmonton: 'High - Most residential zones permit STRs',
      calgary: 'Moderate - Case-by-case approval'
    },
    {
      category: 'Enforcement Approach',
      edmonton: 'Complaint-driven with moderate penalties',
      calgary: 'Proactive monitoring with strict penalties'
    }
  ];

  return (
    <section id="city-comparison" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Edmonton vs Calgary: Key Differences
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Understanding the regulatory differences between Alberta's two major cities is crucial for compliance and operational success.
          </p>
        </div>

        <div className="bg-[#F0F0F0] rounded-2xl overflow-hidden shadow-xl">
          <div className="grid grid-cols-3 bg-[#882629] text-white p-6">
            <div className="font-semibold text-lg">Regulation Category</div>
            <div className="font-semibold text-lg text-center">Edmonton</div>
            <div className="font-semibold text-lg text-center">Calgary</div>
          </div>
          
          {comparisonData.map((row, index) => (
            <div 
              key={index}
              className={`grid grid-cols-3 p-6 ${
                index % 2 === 0 ? 'bg-white' : 'bg-[#F0F0F0]'
              }`}
            >
              <div className="font-semibold text-[#505A5A] pr-4">
                {row.category}
              </div>
              <div className="text-[#505A5A]/70 text-center px-4">
                {row.edmonton}
              </div>
              <div className="text-[#505A5A]/70 text-center px-4">
                {row.calgary}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div className="bg-[#F0F0F0] p-8 rounded-2xl">
            <h3 className="text-2xl font-semibold text-[#505A5A] mb-4 flex items-center gap-3">
              <i className="ri-thumb-up-line text-[#882629]"></i>
              Edmonton Advantages
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">More flexible regulations allow investment property STRs</span>
              </li>
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">No annual rental day limits maximize revenue potential</span>
              </li>
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">Simpler licensing process with faster approval times</span>
              </li>
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">Lower first-year costs and ongoing expenses</span>
              </li>
            </ul>
          </div>

          <div className="bg-[#F0F0F0] p-8 rounded-2xl">
            <h3 className="text-2xl font-semibold text-[#505A5A] mb-4 flex items-center gap-3">
              <i className="ri-thumb-up-line text-[#882629]"></i>
              Calgary Advantages
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">Higher average nightly rates due to tourism and business travel</span>
              </li>
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">Density restrictions reduce competition in neighborhoods</span>
              </li>
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">Stronger market demand during Stampede and events</span>
              </li>
              <li className="flex items-start gap-3 text-[#505A5A]">
                <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">Lower annual renewal costs after initial setup</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
